import { MapPin } from "lucide-react";
import type { ReactNode } from "react";
import { ReviewerAvatar } from "./reviewer-avatar";
import { formatReviewDate } from "./format-review-date";

interface FooterReview {
  date?: string;
  location?: string;
  name: string;
  profileImageUrl?: string;
}

interface CarouselReviewFooterProps {
  review: FooterReview;
  showDates: "yes" | "no";
}

// The reviewer, their town and the date along the bottom of a carousel slide.
const CarouselReviewFooter = ({ review, showDates }: CarouselReviewFooterProps): ReactNode => (
  <div className="jobsite:border-t jobsite:border-border/50 jobsite:pt-6">
    <div className="jobsite:flex jobsite:items-center jobsite:justify-between">
      <div className="jobsite:flex jobsite:items-center jobsite:gap-3">
        <ReviewerAvatar review={review} />
        <div>
          <div className=" jobsite:text-base jobsite:sm:text-lg jobsite:font-heading jobsite:text-card-foreground">
            {review.name}
          </div>
          {Boolean(review.location) && (
            <div className="jobsite:mt-0.5 jobsite:text-sm jobsite:flex jobsite:items-center jobsite:gap-1.5 jobsite:text-muted-foreground">
              <MapPin className="jobsite:w-3.5 jobsite:h-3.5" />
              {review.location}
            </div>
          )}
        </div>
      </div>
      {showDates === "yes" && Boolean(review.date) && (
        <div className="jobsite:text-sm jobsite:text-muted-foreground jobsite:shrink-0">
          {formatReviewDate(review.date)}
        </div>
      )}
    </div>
  </div>
);

export { CarouselReviewFooter };
